module.exports = __webpack_public_path__ + "img/GIS_Right_to_Assembly.78ab0a81.svg";